/**
 * Labels for EventBus subscribers and emit `publisher` metadata — single vocabulary for logs/grep.
 */
export const TrackingTag = {
  Anonymous: 'anonymous',
  TrackingClient: 'TrackingClient',
  TabService: 'TabService',
  CustomerService: 'CustomerService',
  DeviceService: 'DeviceService',
  HeartbeatLoop: 'HeartbeatLoop',
  TabVisibilityMonitor: 'TabVisibilityMonitor',
  Shopware66Adapter: 'Shopware66Adapter',
  BroadcastChannel: 'BroadcastChannel',
} as const;
